import { ApiService } from "../..";

export const fetchSampleListByQuery = (
  join?: Record<string, boolean>,
  fields?: string[],
  query?: Record<string, any>
) => {
  return ApiService.baseAction(
    "sample/list",
    {
      data: {
        join,
        fields,
        query,
      },
    },
    "POST"
  );
};
